import { render, staticRenderFns } from "./ScoreManagement.vue?vue&type=template&id=21bf3c35&scoped=true&"
import script from "./ScoreManagement.vue?vue&type=script&lang=js&"
export * from "./ScoreManagement.vue?vue&type=script&lang=js&"
import style0 from "./ScoreManagement.vue?vue&type=style&index=0&id=21bf3c35&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21bf3c35",
  null
  
)

export default component.exports